import React from 'react';
import { Header } from 'react-aria-components';

import styles from './Menu.module.scss';

type Props = {
  children: React.ReactNode;
};
export const MenuHeader = ({ children }: Props) => {
  return <Header className={styles.MenuHeader}>{children}</Header>;
};
